//react
import React, { useState, useEffect } from "react";

//Css
import "../Surveys.css";

//hooks
import { useCurrentLanguage } from "../../../hooks/useCurrentLanguage";

//paparse
import { parse } from "papaparse";

//components
import SurveyNational from "../../reusable/SurveyNational/SurveyNational";

//assets
import TEXT from "../../../utils/text/surveys_national.json";

async function getData(url) {
  const data = parse(await fetchCsv(url), { header: true });
  return data.data;
}

async function fetchCsv(url) {
  const response = await fetch(url);
  const reader = response.body.getReader();
  const result = await reader.read();
  const decoder = new TextDecoder("utf-8");
  const csv = await decoder.decode(result.value);
  return csv;
}

export default function Chile({ survey }) {
  //language
  const { language } = useCurrentLanguage();

  //useState - data
  const [data, setData] = useState([]);

  //useState - questions
  const [questions, setQuestions] = useState([]);

  //useEffect
  useEffect(() => {
    if (survey !== "") handleGetData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [language, survey]);

  //handle get data
  const handleGetData = async () => {
    const csv1 = await getData("/surveysNational/chile_q1.csv");
    const csv2 = await getData(
      `/surveysNational/${language === "en" ? "/en/" : ""}chile_q2.csv`
    );
    const csv3 = await getData(
      `/surveysNational/${language === "en" ? "/en/" : ""}chile_q3.csv`
    );
    const csv4 = await getData(`/surveysNational/chile_q4.csv`);
    const csv5 = await getData("/surveysNational/chile_q5.csv");
    const csv6 = await getData(
      `/surveysNational/${language === "en" ? "/en/" : ""}chile_q6.csv`
    );
    const csv7 = await getData("/surveysNational/chile_q7.csv");
    const csv8 = await getData("/surveysNational/chile_q8.csv");
    const csv9 = await getData(
      `/surveysNational/${language === "en" ? "/en/" : ""}chile_q9_1.csv`
    );
    const csv9_2 = await getData(
      `/surveysNational/${language === "en" ? "/en/" : ""}chile_q9_2.csv`
    );
    const csv10 = await getData(
      `/surveysNational/${language === "en" ? "/en/" : ""}chile_q10.csv`
    );
    const csv11 = await getData(
      `/surveysNational/${language === "en" ? "/en/" : ""}chile_q11.csv`
    );
    const csv12 = await getData(
      `/surveysNational/${language === "en" ? "/en/" : ""}chile_q12.csv`
    );
    const csv14 = await getData(
      `/surveysNational/${language === "en" ? "/en/" : ""}chile_q14.csv`
    );
    const csv15 = await getData(
      `/surveysNational/${language === "en" ? "/en/" : ""}chile_q15.csv`
    );
    const csv16 = await getData(
      `/surveysNational/${language === "en" ? "/en/" : ""}chile_q16.csv`
    );
    const csv17 = await getData(
      `/surveysNational/${language === "en" ? "/en/" : ""}chile_q17.csv`
    );
    const csv18 = await getData(
      `/surveysNational/${language === "en" ? "/en/" : ""}chile_q18.csv`
    );
    const csv19 = await getData(
      `/surveysNational/${language === "en" ? "/en/" : ""}chile_q19.csv`
    );
    const csv20 = await getData(
      `/surveysNational/${language === "en" ? "/en/" : ""}chile_q20.csv`
    );
    const csv21 = await getData(
      `/surveysNational/${language === "en" ? "/en/" : ""}chile_q21.csv`
    );
    const csv22 = await getData(
      `/surveysNational/${language === "en" ? "/en/" : ""}chile_q22.csv`
    );
    const csv23 = await getData(
      `/surveysNational/${language === "en" ? "/en/" : ""}chile_q23.csv`
    );
    const csv24 = await getData(
      `/surveysNational/${language === "en" ? "/en/" : ""}chile_q24.csv`
    );
    const csv25 = await getData(
      `/surveysNational/${language === "en" ? "/en/" : ""}chile_q25.csv`
    );
    const csv26 = await getData(
      `/surveysNational/${language === "en" ? "/en/" : ""}chile_q26.csv`
    );
    const csv27 = await getData(
      `/surveysNational/${language === "en" ? "/en/" : ""}chile_q27.csv`
    );
    const csv28 = await getData(
      `/surveysNational/${language === "en" ? "/en/" : ""}chile_q28.csv`
    );
    const csv29 = await getData(
      `/surveysNational/${language === "en" ? "/en/" : ""}chile_q29.csv`
    );
    const csv30 = await getData(
      `/surveysNational/${language === "en" ? "/en/" : ""}chile_q30.csv`
    );

    const csv31 = await getData(
      `/surveysNational/${language === "en" ? "/en/" : ""}chile_q31.csv`
    );
    const csv32 = await getData(
      `/surveysNational/${language === "en" ? "/en/" : ""}chile_q32.csv`
    );

    const x_data23 = Object.keys(csv23[0]).filter((e) => e !== "Afirmacion");
    const y_data23 = csv23.map((e) => e["Afirmacion"]);
    const yearData23 = y_data23.map((statement) => {
      return x_data23.map((year) => {
        return Number(csv23.find((e) => e["Afirmacion"] === statement)[year]);
      });
    });
    let data23 = [x_data23, y_data23, yearData23];

    const x_data24 = Object.keys(csv24[0]).filter((e) => e !== "Afirmacion");
    const y_data24 = csv24.map((e) => e["Afirmacion"]);
    const yearData24 = x_data24.map((year) => {
      return csv24.map((e) => Number(e[year]));
    });
    let data24 = [x_data24, y_data24, yearData24];

    const x_data25 = Object.keys(csv25[0]).filter((e) => e !== "Afirmacion");
    const y_data25 = csv25.map((e) => e["Afirmacion"]);
    const yearData25 = x_data25.map((year) => {
      return csv25.map((e) => Number(e[year]));
    });
    let data25 = [x_data25, y_data25, yearData25];

    let data1 = [
      csv1.map((e) => e["Fecha"]),
      csv1.map((e) => Number(e["Porcentaje"])),
    ];
    const y_data2 = csv2.map((e) => e["Problema"]);
    const x_data2 = Object.keys(csv2[0]).filter((e) => e !== "Problema");
    let dat2 = [
      x_data2,
      y_data2.reverse(),
      [
        y_data2.map((e, i) => Number(csv2[i][x_data2[0]])).reverse(),
        y_data2.map((e, i) => Number(csv2[i][x_data2[1]])).reverse(),
        y_data2.map((e, i) => Number(csv2[i][x_data2[2]])).reverse(),
      ],
    ];
    const x_data3 = Object.keys(csv3[0]).filter((e) => e !== "Causas");
    const y_data3 = csv3.map((e) => e["Causas"]);
    const yearData3 = x_data3.map((year) => {
      return csv3.map((e) => Number(e[year]));
    });
    let data3 = [x_data3, y_data3, yearData3];
    let data4 = [
      csv4.map((e) => e["Fecha"]),
      csv4.map((e) => Number(e["Porcentaje"])),
    ];
    let data5 = [
      csv5.map((e) => e["Fecha"]),
      csv5.map((e) => Number(e["Porcentaje"])),
    ];
    const y_data6 = csv6.map((e) => e["Respuesta"]);
    const x_data6 = Object.keys(csv6[0]).filter((e) => e !== "Respuesta");
    let data6 = [
      x_data6,
      y_data6.reverse(),
      [
        y_data6.map((e, i) => Number(csv6[i][x_data6[0]])).reverse(),
        y_data6.map((e, i) => Number(csv6[i][x_data6[1]])).reverse(),
        y_data6.map((e, i) => Number(csv6[i][x_data6[2]])).reverse(),
      ],
    ];

    let data7 = [
      csv7.map((e) => e["Fecha"]),
      csv7.map((e) => Number(e["Porcentaje"])),
    ];
    let data8 = [
      csv8.map((e) => e["Fecha"]),
      csv8.map((e) => Number(e["Porcentaje"])),
    ];

    //q9
    const x_data9 = csv9.map((e) => e["Fecha"]);
    const y_data9 = Object.keys(csv9[0]).filter((e) => e !== "Fecha");
    let data9 = [
      x_data9,
      y_data9,
      [
        y_data9.map((e, i) => Number(csv9[0][y_data9[i]])),
        y_data9.map((e, i) => Number(csv9[1][y_data9[i]])),
        y_data9.map((e, i) => Number(csv9[2][y_data9[i]])),
      ],
    ];

    const x_data9_2 = csv9_2.map((e) => e["Fecha"]);
    const y_data9_2 = Object.keys(csv9_2[0]).filter((e) => e !== "Fecha");
    let data9_2 = [
      x_data9_2,
      y_data9_2,
      [
        y_data9_2.map((e, i) => Number(csv9_2[0][y_data9_2[i]])),
        y_data9_2.map((e, i) => Number(csv9_2[1][y_data9_2[i]])),
        y_data9_2.map((e, i) => Number(csv9_2[2][y_data9_2[i]])),
      ],
    ];

    //q10
    const y_data10 = Object.keys(csv10[0]).filter((e) => e !== "categoria");
    let data10 = [
      csv10.map((e) => e["categoria"]),
      Object.keys(csv10[0]).filter((e) => e !== "categoria"),
      [
        y_data10.map((e) => Number(csv10[0][e])),
        y_data10.map((e) => Number(csv10[1][e])),
        y_data10.map((e) => Number(csv10[2][e])),
      ],
    ];

    //q11
    const y_data11 = Object.keys(csv11[0]).filter((e) => e !== "categoria");
    let data11 = [
      csv11.map((e) => e["categoria"]),
      Object.keys(csv11[0]).filter((e) => e !== "categoria"),
      [
        y_data11.map((e) => Number(csv11[0][e])),
        y_data11.map((e) => Number(csv11[1][e])),
        y_data11.map((e) => Number(csv11[2][e])),
      ],
    ];

    //q12
    let data12 = [
      csv12.map((e) => e["categoria"]),
      csv12.map((e) => Number(e["Porcentaje"])),
    ];

    //q14
    let data14 = [
      csv14.map((e) => e["categoria"]),
      csv14.map((e) => Number(e["Porcentaje"])),
    ];
    //q15
    let data15 = [
      csv15.map((e) => e["categoria"]),
      csv15.map((e) => Number(e["Porcentaje"])),
    ];
    //q16
    //let data16 = [csv16.map((e) => e['categoria']), csv16.map((e) => Number(e['Porcentaje']))];
    let data16 = csv16.map((e) => ({
      value: Number(e["Porcentaje"]),
      name: e["categoria"],
    }));
    //q17
    let data17 = [
      csv17.map((e) => e["categoria"]),
      csv17.map((e) => Number(e["Porcentaje"])),
    ];

    //q18
    const y_data18 = csv18.map((e) => e["Respuesta"]);
    const x_data18 = Object.keys(csv18[0]).filter((e) => e !== "Respuesta");
    let data18 = [
      x_data18,
      y_data18.reverse(),
      [
        y_data18.map((e, i) => Number(csv18[i][x_data18[0]])).reverse(),
        y_data18.map((e, i) => Number(csv18[i][x_data18[1]])).reverse(),
        y_data18.map((e, i) => Number(csv18[i][x_data18[2]])).reverse(),
      ],
    ];

    //q19
    const y_data19 = csv19.map((e) => e["Respuesta"]);
    const x_data19 = Object.keys(csv19[0]).filter((e) => e !== "Respuesta");
    let data19 = [
      x_data19,
      y_data19.reverse(),
      [
        y_data19.map((e, i) => Number(csv19[i][x_data19[0]])).reverse(),
        y_data19.map((e, i) => Number(csv19[i][x_data19[1]])).reverse(),
        y_data19.map((e, i) => Number(csv19[i][x_data19[2]])).reverse(),
      ],
    ];

    //q20
    const y_data20 = csv20.map((e) => e["Respuesta"]);
    const x_data20 = Object.keys(csv20[0]).filter((e) => e !== "Respuesta");
    let data20 = [
      x_data20,
      y_data20.reverse(),
      [
        y_data20.map((e, i) => Number(csv20[i][x_data20[0]])).reverse(),
        y_data20.map((e, i) => Number(csv20[i][x_data20[1]])).reverse(),
      ],
    ];

    //q21
    const data21 = [
      csv21.map((e) => e["categoria"]),
      csv21.map((e) => Number(e["Porcentaje"])),
    ];
    //q22
    const data22 = [
      csv22.map((e) => e["categoria"]),
      csv22.map((e) => Number(e["Porcentaje"])),
    ];

    //q26
    const y_data26 = Object.keys(csv26[0]).filter((e) => e !== "Afirmacion");
    const x_data26 = csv26.map((e) => e["Afirmacion"]);
    const series26 = y_data26.map((e, i) => {
      return x_data26.map((el) =>
        Number(csv26.find((e) => e["Afirmacion"] === el)[y_data26[i]])
      );
    });
    const data26 = [y_data26, x_data26, series26];

    //q27
    const y_data27 = Object.keys(csv27[0]).filter((e) => e !== "Afirmacion");
    const x_data27 = csv27.map((e) => e["Afirmacion"]);
    const series27 = y_data27.map((e, i) => {
      return x_data27.map((el) =>
        Number(csv27.find((e) => e["Afirmacion"] === el)[y_data27[i]])
      );
    });

    const data27 = [y_data27, x_data27, series27];

    //q28
    const data28 = [
      csv28.map((e) => e["Fecha"]),
      csv28.map((e) => Number(e[language === "en" ? "Favourable" : "Buena"])),
      csv28.map((e) => Number(e[language === "en" ? "Unfavourable" : "Mala"])),
    ];

    //q29
    const x_data29 = csv29.map((e) => e["Afirmacion"]);
    const y_data29 = Object.keys(csv29[0]).filter((e) => e !== "Afirmacion");
    const series29 = y_data29.map((e, i) => {
      return x_data29.map((el) =>
        Number(csv29.find((e) => e["Afirmacion"] === el)[y_data29[i]])
      );
    });
    let data29 = [y_data29, x_data29, series29];

    //milestone 25/05/2025: editiing q2!

    //q30
    const y_data30 = Object.keys(csv30[0]).filter((e) => e !== "Afirmacion");
    const x_data30 = csv30.map((e) => e["Afirmacion"]);
    const series30 = y_data30.map((e, i) => {
      return x_data30.map((el) =>
        Number(csv30.find((e) => e["Afirmacion"] === el)[y_data30[i]])
      );
    });
    const data30 = [y_data30, x_data30, series30];

    //
    //q31
    const y_data31 = Object.keys(csv31[0]).filter((e) => e !== "Afirmacion");
    const x_data31 = csv31.map((e) => e["Afirmacion"]);
    const series31 = y_data31.map((e, i) => {
      return x_data31.map((el) =>
        Number(csv31.find((e) => e["Afirmacion"] === el)[y_data31[i]])
      );
    });
    const data31 = [y_data31, x_data31, series31];

    //q31
    const y_data32 = Object.keys(csv32[0]).filter((e) => e !== "Afirmacion");
    const x_data32 = csv32.map((e) => e["Afirmacion"]);
    const series32 = y_data32.map((e, i) => {
      return x_data32.map((el) =>
        Number(csv32.find((e) => e["Afirmacion"] === el)[y_data32[i]])
      );
    });
    const data32 = [y_data32, x_data32, series32];

    let temp = [
      {
        id: "q1",
        question: TEXT["CHI"]["q1"]["question"][language],
        source: TEXT["CHI"]["q1"]["source"][language],
        description: TEXT["CHI"]["q1"]["description"][language],
        narrative: TEXT["CHI"]["q1"]["narrative"][language],
        data: data1,
        graphType: "bar",
        hasOptions: false,
        barLegend: language === "es" ? "Excesiva" : "Excessive",
        survey: TEXT["CHI"]["q1"]["survey"][language],
        link: TEXT["CHI"]["q1"]["link"],
      },
      {
        id: "q2",
        question: TEXT["CHI"]["q2"]["question"][language],
        source: TEXT["CHI"]["q2"]["source"][language],
        description: TEXT["CHI"]["q2"]["description"][language],
        narrative: TEXT["CHI"]["q2"]["narrative"][language],
        data: dat2,
        graphType: "g_h_bar",
        hasOptions: false,
        survey: TEXT["CHI"]["q2"]["survey"][language],
        link: TEXT["CHI"]["q2"]["link"],
      },
      {
        id: "q3",
        question: TEXT["CHI"]["q3"]["question"][language],
        source: TEXT["CHI"]["q3"]["source"][language],
        description: TEXT["CHI"]["q3"]["description"][language],
        narrative: TEXT["CHI"]["q3"]["narrative"][language],
        data: data3,
        graphType: "g_h_bar",
        hasOptions: false,
        isLarge: true,
        survey: TEXT["CHI"]["q3"]["survey"][language],
        link: TEXT["CHI"]["q3"]["link"],
      },
      {
        id: "q4",
        question: TEXT["CHI"]["q4"]["question"][language],
        source: TEXT["CHI"]["q4"]["source"][language],
        description: TEXT["CHI"]["q4"]["description"][language],
        narrative: TEXT["CHI"]["q4"]["narrative"][language],
        data: data4,
        graphType: "bar",
        hasOptions: false,
        barLegend: language === "es" ? "De acuerdo" : "Agree",
        survey: TEXT["CHI"]["q4"]["survey"][language],
        link: TEXT["CHI"]["q4"]["link"],
      },
      {
        id: "q5",
        question: TEXT["CHI"]["q5"]["question"][language],
        source: TEXT["CHI"]["q5"]["source"][language],
        description: TEXT["CHI"]["q5"]["description"][language],
        narrative: TEXT["CHI"]["q5"]["narrative"][language],
        data: data5,
        graphType: "bar",
        hasOptions: false,
        barLegend: language === "es" ? "Sí" : "Yes",
        survey: TEXT["CHI"]["q5"]["survey"][language],
        link: TEXT["CHI"]["q5"]["link"],
      },
      {
        id: "q6",
        question: TEXT["CHI"]["q6"]["question"][language],
        source: TEXT["CHI"]["q6"]["source"][language],
        description: TEXT["CHI"]["q6"]["description"][language],
        narrative: TEXT["CHI"]["q6"]["narrative"][language],
        data: data6,
        graphType: "g_v_bar",
        hasOptions: false,
        survey: TEXT["CHI"]["q6"]["survey"][language],
        link: TEXT["CHI"]["q6"]["link"],
      },
      {
        id: "q7",
        question: TEXT["CHI"]["q7"]["question"][language],
        source: TEXT["CHI"]["q7"]["source"][language],
        description: TEXT["CHI"]["q7"]["description"][language],
        narrative: TEXT["CHI"]["q7"]["narrative"][language],
        data: data7,
        graphType: "bar",
        hasOptions: false,
        barLegend: language === "es" ? "De acuerdo" : "Agree",
        survey: TEXT["CHI"]["q7"]["survey"][language],
        link: TEXT["CHI"]["q7"]["link"],
      },
      {
        id: "q8",
        question: TEXT["CHI"]["q8"]["question"][language],
        source: TEXT["CHI"]["q8"]["source"][language],
        description: TEXT["CHI"]["q8"]["description"][language],
        narrative: TEXT["CHI"]["q8"]["narrative"][language],
        data: data8,
        graphType: "bar",
        hasOptions: false,
        barLegend:
          language === "es"
            ? "Siempre + casi siempre"
            : "Always + almost always",
        survey: TEXT["CHI"]["q8"]["survey"][language],
        link: TEXT["CHI"]["q8"]["link"],
      },
      {
        id: "q9",
        question: TEXT["CHI"]["q9"]["question"][language],
        source: TEXT["CHI"]["q9"]["source"][language],
        description: TEXT["CHI"]["q9"]["description"][language],
        narrative: TEXT["CHI"]["q9"]["narrative"][language],
        narrative2: TEXT["CHI"]["q9_2"]["narrative"][language],
        data: data9,
        data2: data9_2,
        graphType: "g_v_bar",
        options: [
          {
            code: "1",
            label: language === "en" ? "Life and Economy" : "Vida y Economía",
          },
          {
            code: "2",
            label:
              language === "en"
                ? "Society and Polytics"
                : "Sociedad y Políticas",
          },
        ],
        hasOptions: true,
        survey: TEXT["CHI"]["q9"]["survey"][language],
        link: TEXT["CHI"]["q9"]["link"],
        marginBottom: 100,
      },
      {
        id: "q10",
        question: TEXT["CHI"]["q10"]["question"][language],
        source: TEXT["CHI"]["q10"]["source"][language],
        description: TEXT["CHI"]["q10"]["description"][language],
        narrative: TEXT["CHI"]["q10"]["narrative"][language],
        data: data10,
        graphType: "g_v_bar",
        hasOptions: false,
        survey: TEXT["CHI"]["q10"]["survey"][language],
        link: TEXT["CHI"]["q10"]["link"],
      },
      {
        id: "q11",
        question: TEXT["CHI"]["q11"]["question"][language],
        source: TEXT["CHI"]["q11"]["source"][language],
        description: TEXT["CHI"]["q11"]["description"][language],
        narrative: TEXT["CHI"]["q11"]["narrative"][language],
        data: data11,
        graphType: "g_v_bar",
        hasOptions: false,
        survey: TEXT["CHI"]["q11"]["survey"][language],
        link: TEXT["CHI"]["q11"]["link"],
        marginBottom: 100,
      },
      {
        id: "q12",
        question: TEXT["CHI"]["q12"]["question"][language],
        source: TEXT["CHI"]["q12"]["source"][language],
        description: TEXT["CHI"]["q12"]["description"][language],
        narrative: TEXT["CHI"]["q12"]["narrative"][language],
        data: data12,
        graphType: "bar",
        hasOptions: false,
        //barLegend: language === 'es' ? "Sí" : "Yes",
        survey: TEXT["CHI"]["q12"]["survey"][language],
        link: TEXT["CHI"]["q12"]["link"],
      },
      // {
      //      id: "q13",
      //      question: TEXT['CHI']['q13']['question'][language],
      //      source: TEXT['CHI']['q13']['source'][language],
      //      description: TEXT['CHI']['q13']['description'][language],
      //      data: data13,
      //      data2: data13_2,
      //      graphType: "g_v_bar",
      //      options: [
      //           { code: "1", label: language === 'en' ? 'Life and Economy' : "Vida y Economía" },
      //           { code: "2", label:  language === 'en' ? 'Society and Polytics' : "Sociedad y Políticas"}
      //      ],
      //      hasOptions: true,
      //      survey: TEXT['CHI']['q13']['survey'][language],
      //      link: TEXT['CHI']['q13']['link'],
      //      marginBottom: 100
      // },
      {
        id: "q14",
        question: TEXT["CHI"]["q14"]["question"][language],
        source: TEXT["CHI"]["q14"]["source"][language],
        description: TEXT["CHI"]["q14"]["description"][language],
        data: data14,
        graphType: "bar",
        hasOptions: false,
        //barLegend: language === 'es' ? "Nunca o casi nunca" : "Never or almost never",
        survey: TEXT["CHI"]["q14"]["survey"][language],
        link: TEXT["CHI"]["q14"]["link"],
      },
      {
        id: "q15",
        question: TEXT["CHI"]["q15"]["question"][language],
        source: TEXT["CHI"]["q15"]["source"][language],
        description: TEXT["CHI"]["q15"]["description"][language],
        data: data15,
        graphType: "bar",
        hasOptions: false,
        //barLegend: language === 'es' ? "Nunca o casi nunca" : "Never or almost never",
        survey: TEXT["CHI"]["q15"]["survey"][language],
        link: TEXT["CHI"]["q15"]["link"],
      },
      {
        id: "q16",
        question: TEXT["CHI"]["q16"]["question"][language],
        source: TEXT["CHI"]["q16"]["source"][language],
        description: TEXT["CHI"]["q16"]["description"][language],
        data: data16,
        graphType: "pie",
        hasOptions: false,
        barLegend: language === "es" ? "De acuerdo" : "Agree",
        survey: TEXT["CHI"]["q16"]["survey"][language],
        link: TEXT["CHI"]["q16"]["link"],
      },
      {
        id: "q17",
        question: TEXT["CHI"]["q17"]["question"][language],
        source: TEXT["CHI"]["q17"]["source"][language],
        description: TEXT["CHI"]["q17"]["description"][language],
        data: data17,
        graphType: "bar",
        hasOptions: false,
        barLegend: language === "es" ? "De acuerdo" : "Agree",
        survey: TEXT["CHI"]["q17"]["survey"][language],
        link: TEXT["CHI"]["q17"]["link"],
        marginBottom: 80,
      },
      {
        id: "q18",
        question: TEXT["CHI"]["q18"]["question"][language],
        source: TEXT["CHI"]["q18"]["source"][language],
        description: TEXT["CHI"]["q18"]["description"][language],
        data: data18,
        graphType: "g_v_bar",
        hasOptions: false,
        survey: TEXT["CHI"]["q18"]["survey"][language],
        link: TEXT["CHI"]["q18"]["link"],
        legendLabel: language === "es" ? "Mucho + Bastante" : "Much + Quite",
      },
      {
        id: "q19",
        question: TEXT["CHI"]["q19"]["question"][language],
        source: TEXT["CHI"]["q19"]["source"][language],
        description: TEXT["CHI"]["q19"]["description"][language],
        data: data19,
        graphType: "g_v_bar",
        hasOptions: false,
        survey: TEXT["CHI"]["q19"]["survey"][language],
        link: TEXT["CHI"]["q19"]["link"],
        legendLabel: language === "es" ? "De acuerdo" : "Agree",
      },
      {
        id: "q20",
        question: TEXT["CHI"]["q20"]["question"][language],
        source: TEXT["CHI"]["q20"]["source"][language],
        description: TEXT["CHI"]["q20"]["description"][language],
        data: data20,
        graphType: "g_v_bar",
        hasOptions: false,
        survey: TEXT["CHI"]["q20"]["survey"][language],
        link: TEXT["CHI"]["q20"]["link"],
        legendLabel: language === "es" ? "Bueno" : "Good",
      },
      {
        id: "q21",
        question: TEXT["CHI"]["q21"]["question"][language],
        source: TEXT["CHI"]["q21"]["source"][language],
        description: TEXT["CHI"]["q21"]["description"][language],
        data: data21,
        graphType: "bar",
        hasOptions: false,
        //barLegend: language === 'es' ? "Nunca o casi nunca" : "Never or almost never",
        survey: TEXT["CHI"]["q21"]["survey"][language],
        link: TEXT["CHI"]["q21"]["link"],
      },
      {
        id: "q22",
        question: TEXT["CHI"]["q22"]["question"][language],
        source: TEXT["CHI"]["q22"]["source"][language],
        description: TEXT["CHI"]["q22"]["description"][language],
        data: data22,
        graphType: "bar",
        hasOptions: false,
        barLegend: language === "es" ? "De acuerdo" : "Agree",
        survey: TEXT["CHI"]["q22"]["survey"][language],
        link: TEXT["CHI"]["q22"]["link"],
      },
      {
        id: "q23",
        question: TEXT["CHI"]["q23"]["question"][language],
        source: TEXT["CHI"]["q23"]["source"][language],
        description: TEXT["CHI"]["q23"]["description"][language],
        data: data23,
        graphType: "area",
        hasOptions: false,
        survey: TEXT["CHI"]["q23"]["survey"][language],
        link: TEXT["CHI"]["q23"]["link"],
      },
      {
        id: "q24",
        question: TEXT["CHI"]["q24"]["question"][language],
        source: TEXT["CHI"]["q24"]["source"][language],
        description: TEXT["CHI"]["q24"]["description"][language],
        data: data24,
        graphType: "g_v_bar",
        hasOptions: false,
        survey: TEXT["CHI"]["q24"]["survey"][language],
        link: TEXT["CHI"]["q24"]["link"],
        marginBottom: 150,
      },
      {
        id: "q25",
        question: TEXT["CHI"]["q25"]["question"][language],
        source: TEXT["CHI"]["q25"]["source"][language],
        description: TEXT["CHI"]["q25"]["description"][language],
        data: data25,
        graphType: "g_v_bar",
        hasOptions: false,
        survey: TEXT["CHI"]["q25"]["survey"][language],
        link: TEXT["CHI"]["q25"]["link"],
        marginBottom: 70,
      },
      {
        id: "q26",
        question: TEXT["CHI"]["q26"]["question"][language],
        source: TEXT["CHI"]["q26"]["source"][language],
        description: TEXT["CHI"]["q26"]["description"][language],
        data: data26,
        graphType: "s_h_bar",
        hasOptions: false,
        survey: TEXT["CHI"]["q26"]["survey"][language],
        link: TEXT["CHI"]["q26"]["link"],
        marginBottom: 70,
        label: "?? wtf",
      },
      {
        id: "q27",
        question: TEXT["CHI"]["q27"]["question"][language],
        source: TEXT["CHI"]["q27"]["source"][language],
        description: TEXT["CHI"]["q27"]["description"][language],
        data: data27,
        graphType: "g_h_bar",
        hasOptions: false,
        survey: TEXT["CHI"]["q27"]["survey"][language],
        link: TEXT["CHI"]["q27"]["link"],
        marginBottom: 70,
      },
      {
        id: "q28",
        question: TEXT["CHI"]["q28"]["question"][language],
        source: TEXT["CHI"]["q28"]["source"][language],
        description: TEXT["CHI"]["q28"]["description"][language],
        data: data28,
        graphType: "line",
        hasOptions: false,
        survey: TEXT["CHI"]["q28"]["survey"][language],
        link: TEXT["CHI"]["q28"]["link"],
        marginBottom: 70,
      },
      {
        id: "q29",
        question: TEXT["CHI"]["q29"]["question"][language],
        source: TEXT["CHI"]["q29"]["source"][language],
        description: TEXT["CHI"]["q29"]["description"][language],
        data: data29,
        graphType: "g_v_bar",
        hasOptions: false,
        survey: TEXT["CHI"]["q29"]["survey"][language],
        link: TEXT["CHI"]["q29"]["link"],
        marginBottom: 70,
      },
      // Milestone reached: 28 questions! breakpoint
      {
        id: "q30",
        question: TEXT["CHI"]["q30"]["question"][language],
        source: TEXT["CHI"]["q30"]["source"][language],
        description: TEXT["CHI"]["q30"]["description"][language],
        data: data30,
        graphType: "g_h_bar",
        hasOptions: false,
        survey: TEXT["CHI"]["q30"]["survey"][language],
        link: TEXT["CHI"]["q30"]["link"],
        marginBottom: 70,
      },
      {
        id: "q31",
        question: TEXT["CHI"]["q31"]["question"][language],
        source: TEXT["CHI"]["q31"]["source"][language],
        description: TEXT["CHI"]["q31"]["description"][language],
        data: data31,
        graphType: "g_h_bar",
        hasOptions: false,
        survey: TEXT["CHI"]["q31"]["survey"][language],
        link: TEXT["CHI"]["q31"]["link"],
        marginBottom: 70,
      },
      {
        id: "q32",
        question: TEXT["CHI"]["q32"]["question"][language],
        source: TEXT["CHI"]["q32"]["source"][language],
        description: TEXT["CHI"]["q32"]["description"][language],
        data: data32,
        graphType: "g_h_bar",
        hasOptions: false,
        survey: TEXT["CHI"]["q32"]["survey"][language],
        link: TEXT["CHI"]["q32"]["link"],
        marginBottom: 70,
      },
    ];
    let tempQ = [];
    temp.forEach((e) => {
      if (e.survey === survey) tempQ.push({ code: e.id, label: e.question });
    });
    setData(temp.filter((el) => el.survey === survey));
    setQuestions(tempQ);
  };

  return <SurveyNational data={data} questions={questions} title={survey} />;
}
